import React, { useMemo } from 'react'
import {} from 'react-redux'
import Skeleton from 'react-loading-skeleton'

import AvailabilityRequestStats from './AvailabilityRequestStats'
import UserStats from './UserStats'
import AvailabilityMatchStats from './AvailabilityMatchStats'

const StatWraper = ({ children }) => (
  <div className="bg-white border border-gray-400 p-4 rounded-md shadow-md">{children}</div>
)
const StatValue = ({ children }) => (
  <span className="tracking-wide text-4xl font-bold text-gray-600">{children}</span>
)
const StatTitle = ({ children }) => <span className="text-lg text-gray-500 block">{children}</span>
const StatPercent = ({ children }) => <span className="text-xl text-gray-400 ml-2">{children}</span>

export const Stats = () => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <UserStats />
      <AvailabilityRequestStats />
    </div>
  )
}

export const Stat = ({ stat }) => {
  const formattedValue = useMemo(() => (stat.value2 ? `${stat.value} / ${stat.value2}` : stat.value), [stat])
  const valuePercent = useMemo(() => Math.round(((stat.value || 0) / (stat.value2 || 1)) * 100), [stat])

  return (
    <StatWraper>
      <div>
        <StatValue>{(stat.value && formattedValue) || <Skeleton width="12ch" />}</StatValue>
        <StatPercent>
          {stat.value && stat.value2 && valuePercent}
          {stat.value && stat.value2 && '%'}
        </StatPercent>
      </div>
      <StatTitle>{stat.title}</StatTitle>
    </StatWraper>
  )
}

export default Stats
